import React from 'react';
import { connect } from 'react-redux';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import Recaptcha from 'react-recaptcha';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './ContactCo.css';
import { DynamicBackground } from './../../components';
import { contactActions } from './../../actions';
import { isWebpSupported } from 'react-image-webp/dist/utils';

class ContactPageForm extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);

    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  constructor(props, context) {
    super(props, context);

    this.handleClose = this.handleClose.bind(this);

    this.onCheckBoxChange = this.onCheckBoxChange.bind(this);

    this.state = {
      show: false,
    };
  }

  handleClose() {
    this.props.dispatch(contactActions.clearState())
  }

  onCheckBoxChange() {
    const { setFieldValue, values } = this.props;
    const { terms } = values;
    setFieldValue("terms", !terms);
  }

  render() {
    const {
      touched,
      errors,
      // dirty,
      setFieldValue,
      // setSubmitting,
      handleChange,
      handleSubmit,
      isValid,
      values,
      sended,
      t,
    } = this.props;

    return (
      <DynamicBackground customOverlay="rgba(0, 0, 0, 0.6)" background={isWebpSupported() ? "https://gecorcloud.com/images/backgroundContact.webp" : "https://gecorcloud.com/images/backgroundContact.jpg"}>
        <Container>
          <div className="box-contact">
            <div className="box-content">
              <div className="claim-getg">
                <div className="titl-g-1">
                  <b>Obtener nuevas funcionalidades de GECOR</b>
                </div>
                <div className="body-g-1">
                  <p>En estos momentos en los que la comunicación se ha convertido en una poderosa herramienta de contacto y solidaridad entre la ciudadanía y su Ayuntamiento, el equipo de GECOR SYSTEM ha decidido habilitar la plataforma <b>GECOR</b> (con App móvil para su municipio) a disposición de todos los ayuntamientos españoles de <b>FORMA GRATUITA</b>.</p>
                  <br></br>
                  <p>A través de <b>GECOR</b> su ayuntamiento podrá:</p>
                  <br></br>
                  <div className="list-g-1">
                    <p>- Comunicar a sus ciudadanos y ciudadanas <b>noticias</b> municipales, nacionales o autonómicas, estableciendo un canal confiable de información y disminuyendo así el impacto de las <b>FAKE NEWS</b>.</p>
                    <p>- Gestionar <b>actividades</b> como:</p>
                    <div className="actividades">
                      <p>- Comunicaciones y donaciones.</p>
                      <p>- Solicitar ayudas para personas sin hogar.</p>
                      <p>- Informar de incumplimientos del estado de alarma en la vía publica.</p>
                      <p>- Solicitud de limpieza con esterilización.</p>
                      <p>- Remitir datos para ser Voluntario/a.</p>
                    </div>
                    <br></br>
                    <p>Ayuntamientos de ciudades como <b>Granada, Torremolinos, Mijas y Fuengirola</b>, ya han puesto en marcha este nuevo módulo, junto a otras funcionalidades específicas para este momento que estamos viviendo.</p>
                    <p>Les adjuntamos información, notas de prensa y enlaces en los ayuntamientos en los que está funcionando para que pueda verlo en directo.</p>
                    <p>Esperamos que esta iniciativa sea útil para su municipio y ciudadanos y ciudadanas. <b>Si están interesados no duden en ponerse en contacto con nosotros</b>.</p>
                    <p><b>Reciban un cordial saludo.</b></p>
                    <br></br>
                    <div className="info-adj">
                      <h2>INFORMACIÓN ADJUNTA</h2>
                      <br></br>
                      <p><b></b>Vídeo explicativo del funcionamiento del nuevo <b>MÓDULO DE NOTICIAS:</b></p>
                      <br></br>
                      <iframe title="iframe1"  src="https://www.youtube.com/embed/9-EcSGM6i4E" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      <br></br>
                      <br></br>
                      <p><b>Notas de prensa</b> del Ayuntamiento de Granada:</p>
                      <p><a href="https://www.granadadigital.es/app-granada-mejora-nueva-seccion-coronavirus/?fbclid=IwAR2m5gs54-Nl5fg5QzDQy7MTjPqNea1_hnrWGb6VTdXhEZSGWaBDCNz6Hsk" alt="notice1">App Granada Mejora, nueva sección Coronavirus</a></p>
                      <p><a href="https://www.ideal.es/granada/gecor-permite-denunciar-vecino-saltarse-confinamiento-estado-alarma-coronavirus-20200417173833-nt.html?ref=https%3A%2F%2Fwww.google.com%2F?edtn=granada#vca=fixed-btn&vso=rrss&vmc=wh&vli=Granada" alt="notice1">Así es Gecor, la app para avisar a la Policía Local de infracciones del estado de alarma</a></p>
                      <br></br>
                      <p><b>Entrevista</b> a la Concejala de Participación Ciudadana del Ayuntamiento de Granada:</p>
                      <br></br>
                      <iframe title="iframe2" src="https://www.youtube.com/embed/vF7R3rRBhe4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <br></br>
                  </div>
                  
                  
                </div>
              </div>
              <div className="primer-texto">
                <h2> Solicita información </h2>
              </div>
              <Col xs={12} md={12} className="img-email2">
                <Image alt="email" className="img-email" src={isWebpSupported() ? "https://gecorcloud.com/images/Email.webp" : "https://gecorcloud.com/images/Email.png"} rounded />
              </Col>
              <Form noValidate onSubmit={handleSubmit} validated={isValid}>
                <Row className="row-box" >
                  <Col md={6} xs={12}>
                    <Form.Group as={'div'} className="div-cajas" controlId="validationFormikName">
                      <Form.Control required name="name" className="div-cajas2" placeholder={t('contactg.p1')}
                        onChange={handleChange} value={values.name} isInvalid={!!errors.name} isValid={touched.name && !errors.name} />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={'div'} className="div-cajas" controlId="validationFormikEmail">
                      <Form.Control name="email" className="div-cajas2" type="email" placeholder={t('contactg.p2')}
                        required onChange={handleChange} value={values.email} isInvalid={!!errors.email} isValid={touched.email && !errors.email} />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={'div'} className="div-cajas" controlId="validationFormikPhone">
                      <Form.Control name="phone" className="div-cajas2" placeholder={t('contactg.p3')}
                        required onChange={handleChange} value={values.phone} isInvalid={!!errors.phone} isValid={touched.phone && !errors.phone} />
                      <Form.Control.Feedback type="invalid">
                        {errors.phone}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={12}>
                    <Form.Group as={'div'} className="box-mensaje" controlId="validationFormikBody">
                      <Form.Control name="body" className="box-mensaje2" placeholder={"Ayuntamiento*"} as="textarea" maxLength="376" rows="3"
                        required onChange={handleChange} value={values.body} isInvalid={!!errors.body} isValid={touched.body && !errors.body} />
                      <Form.Control.Feedback type="invalid">
                        {errors.body}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <div className="recaptcha-g">
                      <Row>
                        <Form.Group as={Col} controlId="validationFormikTerms">
                          <Form.Check name="terms" className="color-heLeido" label={t('contactg.p5')}
                            required custom type={'checkbox'} onChange={this.onCheckBoxChange} checked={values.terms} isInvalid={!!errors.terms} feedback={errors.terms} />
                          <a className="aviso-legal" target="_blank" rel="noopener noreferrer" href="./legal-advice" >{t('contactg.p6')}</a>
                        </Form.Group>
                        { /* <confirmLegal /> */}
                        <Form.Group as={Col} controlId="recaptcha">
                          <Recaptcha
                            sitekey="6LdVQ6wUAAAAAAoJOy_Yl7UPs4Vje8IWwvU7-8T7" // V2
                            // sitekey="6LfcQqwUAAAAAOepXykaiBTSvaXr2fmJhfRIjq3_" // V3
                            render="explicit"
                            // theme="dark"
                            hl={i18next.language || window.localStorage.i18nextLng}
                            verifyCallback={(response) => { setFieldValue("recaptcha", response); }}
                            onloadCallback={() => {}}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.recaptcha}
                          </Form.Control.Feedback>
                          {errors.recaptcha
                            && touched.recaptcha && (
                              <p>{errors.recaptcha}</p>
                            )}
                        </Form.Group>

                        <Col>
                          <Button className="buttom-hazTu bottonEnv" variant="primary" type="submit"> {t('contactg.p11')} </Button>

                          <div className="modal-contact">
                            <Modal show={sended} onHide={this.handleClose}>
                              <Modal.Header closeButton>
                                <Modal.Title>{t('contactg.p7')}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <p>{t('contactg.p8')}</p>
                                <p>{t('contactg.p9')}</p>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="secondary" onClick={this.handleClose}>
                                  {t('contactg.p10')}
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </div>

                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </Container>
      </DynamicBackground>
    );
  }
}

const initialValuesFormik = {
  name: '',
  email: '',
  phone: '',
  subject: 'Contacto desde la web ciudadano',
  body: '',
  terms: false,
  recaptcha: "",
}

/*  MODAL PARA CONFIRMAR AVISO LEGAL   */
/*
function confirmLegal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


 */

const tContactPageForm = withTranslation()(ContactPageForm);
const formikEnhancer = withFormik({
  validationSchema: ({ t }) => Yup.object().shape({
    name: Yup.string().required('name is required.'),
    email: Yup.string().email('Invalid email address!').required('Email address is required!'),
    phone: Yup.number().required('Phone number is required!').integer().positive(),
    body: Yup.string().required('body is required.'),
    terms: Yup.boolean().required('terms is required.'),
    recaptcha: Yup.string().required(),
  }),
  mapPropsToValues: () => (initialValuesFormik),
  handleSubmit: (payload, { props, setSubmitting, resetForm }) => {
    const { terms } = payload
    if (terms) {
      props.dispatch(contactActions.sendMail(payload))
      setSubmitting(false)
      resetForm(initialValuesFormik)
      // handleShow();
    }

  },
  displayName: 'ContactPageForm',
})(tContactPageForm);

const mapStateToProps = (state) => {
  const { contact } = state;
  const { error, sended, sending } = contact;

  return {
    error,
    sended,
    sending,
  };
}

const tFormikEnhancer = withTranslation()(formikEnhancer)
const connectedContactCoPage = connect(
  mapStateToProps
)(tFormikEnhancer);
export { connectedContactCoPage as ContactCoPage };